import React from 'react';
import './modal_message_status.styles.css';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { selectMessageType } from '../../redux/message/message.selector';
import PulseLoader from 'react-spinners/PulseLoader';

const MessageStatusModal = (props) => {
  const { data, messageType } = props;

  return (
    <div className="message_status_container">
      {data.map((customer, i) => {
        return (
          <div key={i} className="record-container">
            <div className="name">{`${customer.name}`}</div>
            {customer[`${messageType.toLowerCase()}Status`] === 'delivered' && (
              <div className="status">Delivered</div>
            )}
            {(customer[`${messageType.toLowerCase()}Status`] ===
              'delivery_unkown' ||
              customer[`${messageType.toLowerCase()}Status`] === 'failed' ||
              customer[`${messageType.toLowerCase()}Status`] ===
                'undelivered' ||
              customer[`${messageType.toLowerCase()}Status`] === 'bounced' ||
              customer[`${messageType.toLowerCase()}Status`] === 'deferred' ||
              customer[`${messageType.toLowerCase()}Status`] === 'dropped') && (
              <div className="status-failed">
                {customer[`${messageType.toLowerCase()}Status`]
                  .replace('_', ' ')
                  .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())}
              </div>
            )}
            {(customer[`${messageType.toLowerCase()}Status`] === 'queued' ||
              customer[`${messageType.toLowerCase()}Status`] === undefined ||
              customer[`${messageType.toLowerCase()}Status`] === 'processed' ||
              customer[`${messageType.toLowerCase()}Status`] === 'sending' ||
              customer[`${messageType.toLowerCase()}Status`] === 'sent' ||
              customer[`${messageType.toLowerCase()}Status`] ===
                'not sent') && (
              <PulseLoader
                color="red"
                loading="true"
                size={3}
                style={{ marginBottom: '5px' }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  messageType: selectMessageType,
});

export default connect(mapStateToProps, null)(MessageStatusModal);
